import Vue from "vue";
export default {
  isWeChatEnv() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /micromessenger/.test(userAgent);
  },
  //json参数转url
  urlCode(url, data) {
    let u = url;
    let n = 0;
    for (const param in data) {
      if (url.indexOf("?") < 0 && n == 0) {
        u += "?" + param + "=" + encodeURIComponent(data[param]);
      } else {
        u += "&" + param + "=" + encodeURIComponent(data[param]);
      }
      n++;
    }
    return u;
  },
  //格式化数字，用于页面输入限制
  formatFloat(ev, fixed = 2) {
    if (fixed == 0) {
      let reg = /^[0-9](\d+)?$/;
      if (!reg.test(ev.target.value)) {
        let reg2 = /^[0-9](\d+)?/;
        if (ev.target.value.match(reg2)) {
          ev.target.value = ev.target.value.match(reg2)[0];
        } else {
          ev.target.value = '';
        }
        ev.target._value = ev.target.value;
      }
      if (ev.target.value !== "") {
        return Number(ev.target.value);
      }
      return ev.target.value;
    } else {
      let reg = new RegExp("(^[1-9]([0-9]+)?(\\.[0-9]{1," + fixed + "})?$)|(^[0-9]\\.[0-9]([0-9]{0," + (fixed - 1) + "})?$)|(^(0){1}$)");
      let reg1 = new RegExp("^[0-9]+\\.{1}$");
      if (!reg.test(ev.target.value) && !reg1.test(ev.target.value)) {
        let reg2 = new RegExp("(^[1-9]([0-9]+)?(\\.[0-9]{1," + fixed + "})?)|(^[0-9]\\.[0-9]([0-9]{0," + (fixed - 1) + "})?)|(^(0){1})");
        if (ev.target.value.match(reg2)) {
          ev.target.value = ev.target.value.match(reg2)[0];
        } else {
          ev.target.value = '';
        }
        ev.target._value = ev.target.value;
      }
      return ev.target.value;
    }
  },
  //回退
  goBack() {
    window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
  },
  //设置session
  removeSession(key) {
    sessionStorage.removeItem(key);
  },
  //设置session
  setSession(key, value) {
    if (value instanceof Object) {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  },
  //获取ession
  getSession(key) {
    let value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  },
  hexToRgba(hex, opacity) {
    return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
  },
  // 设置cookie信息
  setCookie(key, value, days = 30) {
    var exp = new Date();  //获得当前时间
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);  //换成毫秒
    document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + exp.toGMTString();
    // if (value instanceof Object) {
    //   value = JSON.stringify(value);
    // }
    // localStorage.setItem(key, value);
  },
  // 删除cookie
  removeCookie(name) {
    this.setCookie(name, "");
    // localStorage.removeItem(name);
  },
  getEN(i) {
    return String.fromCharCode(i + 65);
  },
  // 获取cookie信息
  getCookie(key) {
    let cookieString = document.cookie;
    let arr = cookieString.split(';');
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
      let a = arr[i].split('=');
      obj[a[0].trim()] = a[1];
    }
    try {
      return JSON.parse(obj[key])
    } catch (e) {
      return obj[key] || ''
    }
    // let value = localStorage.getItem(key);
    // try {
    //   return JSON.parse(value)
    // } catch (e) {
    //   return value
    // }
  },
  //消息弹框
  message(type, message, duration, showClose) {
    if (type == "success") {
      duration = 1000;
    }
    Vue.prototype.$notify({
      showClose: showClose || true,
      message,
      title: "消息提示",
      type: type || "error",
      duration: duration || 2000,
      offset: 40,
      position: "top-right",
      // center: true,
    });
  },
  toast(type, message, duration, forbidClick) {
    if (type == "clear") {
      Vue.prototype.$toast.clear();
    } else {
      Vue.prototype.$toast({
        type,
        message,
        duration: type == "loading" ? 0 : (duration || 2000),
        forbidClic: type == "loading" ? true : forbidClick,
        position: type == "text" ? "bottom" : "middle",
      });
    }
  },
  // 获取用户信息
  getUserInfo() {
    // const pathname = location.pathname.replace(/\//g, "") || "ms";
    // var userInfo = this.getSession("userInfo");
    // if (pathname == "mb") {
    //   userInfo = this.getCookie("userInfo");
    // }
    var userInfo = this.getSession("userInfo")
    if (browser && browser.versions.mobile && !userInfo) {
      userInfo = this.getCookie("userInfo");
    }
    if (typeof userInfo != 'object' || !userInfo) {
      userInfo = {};
    }
    return userInfo;
  },
  //获取token
  getToken() {
    var userInfo = this.getUserInfo();
    if (userInfo && userInfo.token) {
      return (userInfo.token_type || "Bearer") + " " + userInfo.token
    }
    return "";
  },
  getTimestamp(date) {
    var time = this.formatDate(date, "yyyy/MM/dd HH:mm:ss");
    return new Date(time).getTime();
  },
  getNextDays(date, num, format) {
    var timestamp = this.getTimestamp(date) + num * 24 * 60 * 60 * 1000;
    return this.formatDate(timestamp, format);
  },
  getCutTime(type, times) {
    // 计算天、小时、分钟、秒
    var seconds = Math.floor(times / 1000);
    var minutes = Math.floor(seconds / 60);
    var m = minutes < 10 ? "0" + minutes : minutes;
    var hours = Math.floor(minutes / 60);
    var h = hours < 10 ? "0" + hours : hours;
    var remainingMinutes = minutes % 60;
    var rm = remainingMinutes < 10 ? "0" + remainingMinutes : remainingMinutes;
    var remainingSeconds = seconds % 60;
    var rs = remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;
    // 显示总时长
    if (type == "m") {
      return `${m}:${rs}`;
    } else {
      return `${h}:${rm}:${rs}`;
    }
  },
  //时间格式化
  formatDate(date, format, isMoment) {
    if (!date) return "";
    if (!format) format = "yyyy-MM-dd HH:mm:ss";
    var tagNum = /^[0-9]*$/.test(date);
    date = date + "";
    if (!tagNum && date.indexOf("T") < 0) {
      date = date.replace(/-/g, "/");
    }
    if (tagNum || Date.parse(date)) {
      if (tagNum) date = parseInt(date);
      date = new Date(date).getTime();
      if (date.toString().length == 10) {
        date = date * 1000;
      }
      let offest = new Date().getTimezoneOffset();
      if (isMoment) date = date - offest * 1000 * 60;
      let datetime = dateFtt(format, date);
      return datetime;
    } else {
      return date;
    }
    /**************************************时间格式化处理************************************/
    function dateFtt(fmt, date) { //author: meizz   
      var date = new Date(date);
      var o = {
        "M+": date.getMonth() + 1, //月份   
        "d+": date.getDate(), //日   
        "H+": date.getHours(), //小时   
        "m+": date.getMinutes(), //分   
        "s+": date.getSeconds(), //秒   
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
        "S": date.getMilliseconds() //毫秒   
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
  },
  base64() {
    // private property
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    // public method for encoding
    this.encode = function (input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = _utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
          _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
      }
      return output;
    }
    // public method for decoding
    this.decode = function (input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = _utf8_decode(output);
      return output;
    }

    // private method for UTF-8 encoding
    var _utf8_encode = function (string) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }

      }
      return utftext;
    }

    // private method for UTF-8 decoding
    var _utf8_decode = function (utftext) {
      var string = "";
      var i = 0;
      var c = c1 = c2 = 0;
      while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if ((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    }
  },
  //url到处文件
  exportExcel(url, target = '') {
    const alink = document.createElement('a');
    alink.style.display = 'none';
    alink.setAttribute("target", target);
    alink.href = url;
    document.body.appendChild(alink);
    alink.click();
    document.body.removeChild(alink);
  },
  //文件流下载
  fileDownload(data, fileName) {
    const blob = new Blob([data])
    const alink = document.createElement('a');
    alink.download = `${fileName}`;
    alink.href = URL.createObjectURL(blob);
    alink.click();
  },
  //去左右空格;
  trim(s) {
    return s.replace(/(^\s*)|(\s*$)/g, "");
  },
  //十六进制颜色转RGB
  hex2rgb(color) {
    if (!color) return false;
    color = color.substring(1);
    color = color.toLowerCase();
    let b = [];
    for (let x = 0; x < 3; x++) {
      b[0] = color.substr(x * 2, 2);
      b[3] = "0123456789abcdef";
      b[1] = b[0].substr(0, 1);
      b[2] = b[0].substr(1, 1);
      b[20 + x] = b[3].indexOf(b[1]) * 16 + b[3].indexOf(b[2]);
    }
    // console.log([b[20],b[21],b[22]])
    return [b[20], b[21], b[22]];
    // return "rgb(" +b[20]+","+b[21]+","+b[22]+ ")";
  },
  lowercaseFirstLetter(obj) {
    if (typeof obj == "string") {
      return str.slice(0, 1).toLowerCase() + str.slice(1);
    }
    if (typeof obj == "object") {
      let data = obj;
      for (let key in data) {
        let s = key.slice(0, 1).toLowerCase() + key.slice(1);
        data[s] = data[key];
        delete data[key];
      }
      return data;
    }
    return obj;
  },
  //保留小数点，只舍不入
  retainDecimal(num, fixed) {
    num = num + "";
    if (num.indexOf(".") < 0) {
      return num;
    }
    return num.substring(0, num.lastIndexOf('.') + (fixed + 1));
  },
  //深拷贝
  depCopy(obj) {
    try {
      return JSON.parse(JSON.stringify(obj))
    } catch (e) {
      return obj
    }
  },
  uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
      var r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join('');
  },
  parseQueryString(type, dataUrl) {
    var url = dataUrl || location.search;
    if (type === 'hash') {
      let temp = location.hash;
      if (dataUrl) {
        temp = dataUrl.split("#")[1];
      }
      url = temp.substring(temp.indexOf("?"));
    }
    var query = {};
    if (url.indexOf("?") !== -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        query[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
      }
    }
    return query;
  },
  fileView(path, server) {
    if (!path) {
      return "";
    }
    if (server == "own") {
      return 'http://47.115.75.110:8012/onlinePreview?url=' + Base64.encode(path);
    } else {
      let target = ['.doc', '.xls', '.ppt'].find(item => path.indexOf(item) > 0);
      if (target) {
        return "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(path);
      } else {
        return path;
      }
    }
  },
  platform(value) {
    var platform = "";
    switch (value) {
      case "ms": platform = "管理端"; break;
      case "pc": platform = "客户端"; break;
      case "mb": platform = "手机端"; break;
      default: platform = "其他";
    }
    return platform;
  },
  imageResize(url, w, h) {
    if (url.indexOf("x-oss-process=image") >= 0) {
      return `${url}/resize,w_${w},h_${h}`
    } else {
      return `${url}?x-oss-process=image/resize,w_${w},h_${h}`
    }
  },
  random(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  },
  getDateDays(date, cycle) {
    var obj = {
      date: date,
      // cycle,
      total: this.getDaysBetween(cycle.cycleStartTime, cycle.cycleEndTime),
      days: this.getDaysBetween(cycle.cycleStartTime, date),
    };
    obj.percent = Number((obj.days / obj.total * 100).toFixed(2));
    if (obj.percent < 0) {
      obj.percent = 0;
    }
    if (obj.percent > 100) {
      obj.percent = 100;
    }
    return obj;
  },
  getDaysInMonth(year, month) {
    let date = new Date(year, month, 1);
    return new Date(date.getTime() - 864e5).getDate();
  },
  getYearDays(year) {
    year = year || new Date().getFullYear();
    var isLeap = year % 4 == 0 && year % 100 != 0 || year % 400 == 0;
    return isLeap ? 366 : 365;
  },
  getDaysBetween(start, end) {
    var startDate = Date.parse(start);
    var endDate = Date.parse(end);
    if (startDate > endDate) {
      return 0;
    }
    // if (startDate==endDate){
    //     return 1;
    // }
    var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    return days;
  },
  getWeekNumber(value) {
    const date = value ? new Date(value) : new Date();
    const startOfYear = new Date(date.getFullYear(), 0, 1); // 获取年初
    const diff = date - startOfYear; // 日期差值
    const oneDay = 1000 * 60 * 60 * 24; // 一天的毫秒数
    const pastDays = Math.ceil(diff / oneDay); // 过去的天数
    return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7); // 计算周数
  },
  countSubstring(str, sub) {
    let count = 0;
    let index = str.indexOf(sub);
    while (index !== -1) {
      count++;
      index = str.indexOf(sub, index + 1);
    }
    return count;
  },
  fullScreen() {
    this.requestFullscreenFunName = null;
    this.exitFullscreenFunName = null;
    this.supprotFullScreen = false;
    let body = document.body;
    if (typeof body.requestFullscreen === 'function') {
      this.requestFullscreenFunName = 'requestFullscreen';
    } else if (typeof body.mozRequestFullScreen === 'function') {
      this.requestFullscreenFunName = 'mozRequestFullScreen';
    } else if (typeof body.msRequestFullscreen === 'function') {
      this.requestFullscreenFunName = 'msRequestFullscreen';
    } else if (typeof body.oRequestFullscreen === 'function') {
      this.requestFullscreenFunName = 'oRequestFullscreen';
    } else if (typeof body.webkitRequestFullscreen === 'function') {
      this.requestFullscreenFunName = 'webkitRequestFullscreen';
    }

    if (typeof document.exitFullscreen === 'function') {
      this.exitFullscreenFunName = 'exitFullscreen';
    } else if (typeof document.msExitFullscreen === 'function') {
      this.exitFullscreenFunName = 'msExitFullscreen';
    } else if (typeof document.mozCancelFullScreen === 'function') {
      this.exitFullscreenFunName = 'mozCancelFullScreen';
    } else if (typeof document.oRequestFullscreen === 'function') {
      this.exitFullscreenFunName = 'oRequestFullscreen';
    } else if (typeof document.webkitExitFullscreen === 'function') {
      this.exitFullscreenFunName = 'webkitExitFullscreen';
    }
    this.supprotFullScreen = (null !== this.requestFullscreenFunName && null !== this.exitFullscreenFunName);
    // 进入全屏
    this.enterFullscreen = function (element) {
      if (!this.supprotFullScreen) {
        return;
      }
      element[this.requestFullscreenFunName]();
    };
    // 退出全屏
    this.exitFullscreen = function () {
      if (!this.supprotFullScreen) {
        return;
      }
      document[this.exitFullscreenFunName]();
    }
    document.addEventListener('fullscreenchange', function (event) {
      if (!document.fullscreenElement) {
        // 退出全屏后执行的代码
        // this.exitFullscreen();
      }
    });
  },
  stopMedia() {
    var timer = setTimeout(() => {
      var videos = document.getElementsByTagName("video");
      for (var i = 0; i < videos.length; i++) {
        videos[i].pause();
      }
      var audios = document.getElementsByTagName("audio");
      for (var i = 0; i < audios.length; i++) {
        audios[i].pause();
      }
      clearTimeout(timer);
    })
  },
  calculateAge(birthDate) {
    birthDate = new Date(birthDate);
    var currentDate = new Date();
    var birthYear = birthDate.getFullYear();
    var birthMonth = birthDate.getMonth();
    var birthDayOfMonth = birthDate.getDate();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var currentDayOfMonth = currentDate.getDate();

    var age = currentYear - birthYear;
    if (currentMonth < birthMonth || (currentMonth == birthMonth && currentDayOfMonth < birthDayOfMonth)) {
      age--;
    }
    return age;
  },
  getNationList() {
    return [
      {
        id: 1,
        name: '汉族',
        value: '汉族'
      },
      {
        id: 2,
        name: '壮族',
        value: '壮族'
      },
      {
        id: 3,
        name: '满族',
        value: '满族'
      },
      {
        id: 4,
        name: '回族',
        value: '回族'
      },
      {
        id: 5,
        name: '苗族',
        value: '苗族'
      },
      {
        id: 6,
        name: '维吾尔族',
        value: '维吾尔族'
      },
      {
        id: 7,
        name: '土家族',
        value: '土家族'
      },
      {
        id: 8,
        name: '彝族',
        value: '彝族'
      },
      {
        id: 9,
        name: '蒙古族',
        value: 9
      },
      {
        id: 10,
        name: '藏族',
        value: '藏族'
      },
      {
        id: 11,
        name: '布依族',
        value: '布依族'
      },
      {
        id: 12,
        name: '侗族',
        value: '侗族'
      },
      {
        id: 13,
        name: '瑶族',
        value: '瑶族'
      },
      {
        id: 14,
        name: '朝鲜族',
        value: '朝鲜族'
      },
      {
        id: 15,
        name: '白族',
        value: '白族'
      },
      {
        id: 16,
        name: '哈尼族',
        value: '哈尼族'
      },
      {
        id: 17,
        name: '哈萨克族',
        value: '哈萨克族'
      },
      {
        id: 18,
        name: '黎族',
        value: '黎族'
      },
      {
        id: 19,
        name: '傣族',
        value: '傣族'
      },
      {
        id: 20,
        name: '畲族',
        value: '畲族'
      },
      {
        id: 21,
        name: '傈僳族',
        value: '傈僳族'
      },
      {
        id: 22,
        name: '仡佬族',
        value: '仡佬族'
      },
      {
        id: 23,
        name: '东乡族',
        value: '东乡族'
      },
      {
        id: 24,
        name: '高山族',
        value: '高山族'
      },
      {
        id: 25,
        name: '拉祜族',
        value: '拉祜族'
      },
      {
        id: 26,
        name: '水族',
        value: '水族'
      },
      {
        id: 27,
        name: '佤族',
        value: '佤族'
      },
      {
        id: 28,
        name: '纳西族',
        value: '纳西族'
      },
      {
        id: 29,
        name: '羌族',
        value: '羌族'
      },
      {
        id: 30,
        name: '土族',
        value: '土族'
      },
      {
        id: 31,
        name: '仫佬族',
        value: '仫佬族'
      },
      {
        id: 32,
        name: '锡伯族',
        value: '锡伯族'
      },
      {
        id: 33,
        name: '柯尔克孜族',
        value: '柯尔克孜族'
      },
      {
        id: 34,
        name: '达斡尔族',
        value: '达斡尔族'
      },
      {
        id: 35,
        name: '景颇族',
        value: '景颇族'
      },
      {
        id: 36,
        name: '毛南族',
        value: '毛南族'
      },
      {
        id: 37,
        name: '撒拉族',
        value: '撒拉族'
      },
      {
        id: 38,
        name: '布朗族',
        value: '布朗族'
      },
      {
        id: 39,
        name: '塔吉克族',
        value: '塔吉克族'
      },
      {
        id: 40,
        name: '阿昌族',
        value: '阿昌族'
      },
      {
        id: 41,
        name: '普米族',
        value: '普米族'
      },
      {
        id: 42,
        name: '鄂温克族',
        value: '鄂温克族'
      },
      {
        id: 43,
        name: '怒族',
        value: '怒族'
      },
      {
        id: 44,
        name: '京族',
        value: '京族'
      },
      {
        id: 45,
        name: '基诺族',
        value: '基诺族'
      },
      {
        id: 46,
        name: '德昂族',
        value: '德昂族'
      },
      {
        id: 47,
        name: '保安族',
        value: '保安族'
      },
      {
        id: 48,
        name: '俄罗斯族',
        value: '俄罗斯族'
      },
      {
        id: 49,
        name: '裕固族',
        value: '裕固族'
      },
      {
        id: 50,
        name: '乌孜别克族',
        value: '乌孜别克族'
      },
      {
        id: 51,
        name: '门巴族',
        value: '门巴族'
      },
      {
        id: 52,
        name: '鄂伦春族',
        value: '鄂伦春族'
      },
      {
        id: 53,
        name: '独龙族',
        value: '独龙族'
      },
      {
        id: 54,
        name: '塔塔尔族',
        value: '塔塔尔族'
      },
      {
        id: 55,
        name: '赫哲族',
        value: '赫哲族'
      },
      {
        id: 56,
        name: '珞巴族',
        value: '珞巴族'
      }
    ]
  },
  attestationType(val) {
    var name = "";
    switch (val) {
      case 1: name = "考试测验"; break;
      case 2: name = "知识认证"; break;
      case 5: name = "技能认证"; break;
      case 9: name = "岗位技能认证"; break;
      default: name = "考试测验"; break;
    }
    return name;
  },
  learnType(val) {
    var name = "";
    val = Number(val);
    switch (val) {
      case 10: name = "训练"; break;
      case 11: name = "强化"; break;
      case 20: name = "测验"; break;
      case 30: name = "考试"; break;
      default: name = "--"; break;
    }
    return name;
  },
  questionType(type, tag) {
    var name = "";
    type = Number(type);
    switch (type) {
      case 1: name = "单选"; break;
      case 2: name = "多选"; break;
      case 3: name = "判断"; break;
      case 4: name = "排序"; break;
      case 5: name = "填空"; break;
      case 6: name = "阅读"; break;
      case 7: name = "简答"; break;
      default: name = ""; break;
    }
    if (tag) {
      if (tag.indexOf(name) >= 0) {
        return tag;
      } else {
        return tag + "•" + name;
      }
    } else {
      return name;
    }
  },
  questionTypeGroup(val) {
    var name = "";
    val = Number(val);
    switch (val) {
      case 1: name = "dx"; break;
      case 2: name = "pd"; break;
      case 3: name = "dx2"; break;
      case 4: name = "px"; break;
      case 5: name = "tk"; break;
      case 6: name = "tk"; break;
      case 7: name = "tk"; break;
      case 8: name = "tk"; break;
      case 9: name = "tk"; break;
      case 11: name = "bdx"; break;
      case 12: name = "bdx"; break;
      case 13: name = "bdx"; break;
      default: name = "tk"; break;
    }
    return name;
  },
  capitalNumber(val, suffix) {
    var arr = [
      "一", "二", "三", "四", "五", "六", "七", "八", "九", "十",
      "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十",
    ];
    return arr[val - 1] + (suffix || "");
  },
  tenantType(val) {
    var name = "";
    switch (val) {
      case 0: name = "企业"; break;
      case 1: name = "企业"; break;
      case 2: name = "学校"; break;
      case 3: name = "学校"; break;
      case 4: name = "学校"; break;
      case 5: name = "学校"; break;
      default: name = "单位"; break;
    }
    return name;
  },
  tenantSort(val) {
    var name = "";
    switch (val) {
      case 1: name = "企业"; break;
      case 2: name = "中职"; break;
      case 3: name = "高职"; break;
      case 4: name = "专科"; break;
      case 5: name = "本科"; break;
      default: name = "单位"; break;
    }
    return name;
  },
  jobType(val) {
    var name = "";
    switch (val) {
      case 1: name = "就业"; break;
      case 2: name = "实习"; break;
      case 3: name = "就业+实习"; break;
      case 4: name = "假期实践"; break;
      default: name = "--"; break;
    }
    return name;
  },
  mutualType(val) {
    var name = "";
    switch (val) {
      case 1: name = "就业"; break;
      case 2: name = "实习"; break;
      case 3: name = "就业实习"; break;
      case 4: name = "假期实践"; break;
      default: name = ""; break;
    }
    return name;
  },
  getPlainText(htmlContent) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(htmlContent, 'text/html');
    let range = doc.createRange();
    range.selectNodeContents(doc.body);
    return range.toString();
  },
  processMessageContent(dom, content) {
    let lastProcessedIndex = 0;
    function processMessageContent(content) {
      let currentIndex = lastProcessedIndex;
      let eventDeltaIndex = content.indexOf('event:conversation.message.delta', currentIndex);

      while (eventDeltaIndex !== -1) {
        // 找到下一个 'event:conversation.message.delta' 的位置
        let nextEventDeltaIndex = content.indexOf('event:conversation.message.delta', eventDeltaIndex + 1);
        let endEventDeltaIndex = nextEventDeltaIndex !== -1 ? nextEventDeltaIndex : content.length;

        // 提取数据部分，移除"data:"前缀并找到 JSON 对象的结束位置 '}'
        let dataString = content.substring(eventDeltaIndex, endEventDeltaIndex);
        let dataIndex = dataString.indexOf('data:');
        let jsonEndIndex = dataString.lastIndexOf('}') + 1;

        // 确保我们找到了完整的 JSON 对象
        if (jsonEndIndex > 0 && dataString[jsonEndIndex - 1] === '}') {
          try {
            // 尝试解析 JSON 对象
            const dataObject = JSON.parse(dataString.substring(dataIndex + 5, jsonEndIndex));
            // 使用打字机效果逐字添加消息
            typeMessage(dataObject.content, true);
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // 更新处理位置
          currentIndex = eventDeltaIndex + jsonEndIndex;
          eventDeltaIndex = nextEventDeltaIndex;
        } else {
          // 如果没有找到完整的 JSON 对象，则停止处理
          break;
        }
      }
      lastProcessedIndex = currentIndex;
    }
    let currentBubbleElement = null; // 用于存储当前正在打字的bubble元素
    function typeMessage(content, isLeft) {
      // 初始化index
      let index = 0;

      // 如果当前bubble元素不存在，或者消息的方向改变了，创建一个新的bubble元素
      if (!currentBubbleElement || !currentBubbleElement.classList.contains('bubble-left')) {
        currentBubbleElement = document.createElement('span');
        currentBubbleElement.className = 'bubble bubble-left'; // 总是使用'bubble-left'样式
        currentBubbleElement.textContent = ''; // 初始化为空字符串

        // 创建一个新的chat-message元素并添加bubble
        const newMessage = document.createElement('span');
        newMessage.className = `chat-message left`; // 确保消息总是使用'left'样式
        newMessage.appendChild(currentBubbleElement);

        // 将新消息添加到chatWindow
        dom.appendChild(newMessage);
      }

      (function typeNextChar() {
        // 逐字添加内容
        if (index < content.length) {
          currentBubbleElement.textContent += content[index]; // 逐字添加
          index++; // 更新索引
          requestAnimationFrame(typeNextChar); // 使用requestAnimationFrame模拟打字效果
        }
      })();
    }
    processMessageContent(content);
  },
  nationalRemainingDays(type) {
    var date = "", days = 0, now = this.formatDate(new Date(), "yyyy-MM-dd"), year = new Date().getFullYear();
    switch (type) {
      case 1: date = "04-01"; break;
      case 2: date = "06-07"; break;
      default: date = "06-07"; break;
    }
    var target = year + "-" + date;
    if (now >= date) {
      target = (year + 1) + "-" + date;
    }
    days = this.getDaysBetween(now, target);
    return days;
  },
  removeExtension(filename) {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) return filename; // 没有后缀名
    return filename.substring(0, lastDotIndex);
  },
}



// WEBPACK FOOTER //
// ./src/utils/func.js